
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useSubscription } from "@/pages/pricing/hooks/useSubscription";
import { FreePlanView } from "./subscription/FreePlanView";
import { SubscriptionActions } from "./subscription/SubscriptionActions";
import { SubscriptionDetails } from "./subscription/SubscriptionDetails";
import { useSubscriptionManagement } from "./subscription/useSubscriptionManagement";
import { SubscriptionAlert } from "@/pages/pricing/components/SubscriptionAlert";

export function SubscriptionManagement() {
  const { isSubscribed, currentSubscription } = useSubscription();
  const {
    isLoading,
    hasActiveProAccess,
    isCancelled,
    startDate,
    billingOrEndDate,
    endDate,
    daysRemaining,
    handleCancelSubscription,
    handleUpgradeSubscription
  } = useSubscriptionManagement(isSubscribed, currentSubscription);

  if (!hasActiveProAccess) {
    return <FreePlanView onUpgrade={handleUpgradeSubscription} />;
  }

  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-xl">Subscription Management</CardTitle>
        <CardDescription>Manage your Pro subscription</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {/* Show subscription alerts inside the card for better context */}
        {currentSubscription && currentSubscription.subscription_status !== 'active' && 
          currentSubscription.subscription_status !== 'cancelled' && (
          <SubscriptionAlert 
            isSubscribed={isSubscribed} 
            currentSubscription={currentSubscription}
          />
        )}
        
        <SubscriptionDetails
          currentSubscription={currentSubscription}
          isCancelled={isCancelled}
          daysRemaining={daysRemaining}
          startDate={startDate}
          billingOrEndDate={billingOrEndDate}
          endDate={endDate}
        />

        <Separator className="my-2" />
        
        <SubscriptionActions
          currentSubscription={currentSubscription}
          isLoading={isLoading}
          onCancelSubscription={handleCancelSubscription}
        />
      </CardContent>
    </Card>
  );
}
